import React from "react";
import Container from "./Container";
import Close from "../assets/CloseIcon.svg";
import Share from "../assets/ShareIcon.svg";
import CustomText from "./CustomText";
import { MatchType } from "./MatchHeaderDropdown";
import { stageType } from "../types/type";

interface Header {
  share?: boolean;
  close?: boolean;
  shadow?: boolean;
  onClose?: () => void;
  onShare?: () => void;
  className?: string;
  stage?: stageType;
}

function Header({
  className,
  close,
  onClose,
  onShare,
  share,
  shadow,
  stage,
}: Header) {
  let style: string;
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleShare = () => {
    if (onShare) {
      onShare();
    }
  };

  style = `header ${
    shadow && stage !== "chooseMatch" ? "headerShadow" : "noTop"
  }`;

  return (
    <Container className={` ${style}`}>
      {/* {stage !== "chooseMatch" ? ( */}
      <div className="headerContent">
        <div></div>
        <div style={{ marginTop: 50 }}>
          <div className="headerButton" onClick={handleShare}>
            <img src={Share} alt="close" />
          </div>
        </div>
        {/* <div>
          {share && (
            <div className="shareButton" onClick={handleShare}>
              <CustomText weight="800" color={"white"} size={"small"}>
                {stage !== "LeaderBoard" ? "  Leaderboard" : "My Picks"}
              </CustomText>
            </div>
          )}
        </div> */}
      </div>
      {/* ) : null} */}
    </Container>
  );
}

export default Header;
